import React, { useState, useEffect, useRef } from "react";
import ReactPlayer from "react-player";
import styled from "styled-components";
import { FaPause, FaPlay } from "react-icons/fa";
import styles from "../styles/Other.module.css";

const AudioPlayerMic = ({ url, style }) => {
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const playerRef = useRef(null);
  const [hasWindow, setHasWindow] = useState(false);
  const [allowProgressUpdate, setAllowProgressUpdate] = useState(true);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setHasWindow(true);
    }
  }, []);

  useEffect(() => {
    if (!playerRef?.current || !allowProgressUpdate) return;
    const interval = setInterval(() => {
      if (playing) {
        const newProgress =
          (playerRef?.current?.getCurrentTime() /
            playerRef?.current?.getDuration()) *
          100;
        setProgress(newProgress);
      }
    }, 50);
    return () => clearInterval(interval);
  }, [playing, allowProgressUpdate]);

  const togglePlay = () => {
    setPlaying(!playing);
  };

  const handlePlaybackEnd = () => {
    setPlaying(false);
    setProgress(0);
    playerRef.current.seekTo(0);
  };

  const handleProgressBarClick = (e) => {
    if (!playerRef.current) return;
    setAllowProgressUpdate(false);
    const progressBarRect = e.currentTarget.getBoundingClientRect();
    const newProgress =
      ((e.clientX - progressBarRect.x) / progressBarRect.width) * 100;
    const newTime = (newProgress * playerRef.current.getDuration()) / 100;
    const roundedTime = Math.round(newTime);
    playerRef.current.seekTo(roundedTime);
    setProgress((roundedTime / playerRef.current.getDuration()) * 100);
    setAllowProgressUpdate(true);
  };

  return (
    <div
      style={{ ...style, borderRadius: 12 }}
      className={`${styles.freePlayerContainer} tw-mt-5`}
    >
      {/* <div className={styles.freeBanner}>
        Free conversions are limited to 45 second demos.
      </div> */}
      <div className={styles.freePlayerControlsContainer}>
        <button className={styles.freePlayerButton} onClick={togglePlay}>
          {playing ? <FaPause size={24} /> : <FaPlay size={24} />}
        </button>
      </div>
      <div
        style={{
          height: 30,
          width: "100%",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={handleProgressBarClick}
      >
        <div className={styles.freePlayerProgressBar}>
          <div
            className={styles.freePlayerProgress}
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
      {hasWindow && (
        <ReactPlayer
          style={{
            display: "none",
          }}
          onEnded={handlePlaybackEnd}
          ref={playerRef}
          url={url}
          playing={playing}
        />
      )}
    </div>
  );
};
export default AudioPlayerMic;
